import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useLocation, useParams } from "react-router-dom";
import { uploadPhotosActions } from "../../../store/state-slices/photosUpload";

//css
import classes from "./Navbar.module.css";
import "./Navbar.css";

// Jds
import {
  ActionButton,
  AvatarV2,
  BadgeV2,
  Button,
  Container,
  Icon,
  Link,
  MenuBlock,
  Notifications,
  ProgressBar,
  SidePanel,
  Text,
  Tooltip,
} from "@jds/core";

// Local
import NewEventButton from "../../UI/Buttons/NewEventButton";
import JdsModal from "../../UI/JdsModal";
import CreateNewEventForm from "../../UI/Form/CreateNewEventForm";
import ProfileDetailForm from "../../UI/Form/ProfileDetailForm";
import useToggle from "../../../hooks/use-toggle";
import AccountDetailPopover from "../../UI/Views/AccountDetailPopover";
import NotificationPopover from "../../UI/Views/notification/NotificationPopover";
import useApiHttp from "../../../hooks/use-http";
import MuiPopover from "../../UI/MuiPopover";
import {
  Box,
  Popover,
  Skeleton,
  Stack,
  Toolbar,
  Tooltip as MuiTooltip,
  Modal,
} from "@mui/material";
import IconRocket from "../../../assets/svg/ic_enterpreneurial.svg";
import IconCloud from "../../../assets/svg/Icon.svg";
import AvatarView from "../../UI/Views/avatarView/AvatarView";
import {
  addParamsURL,
  baseToImg,
  bytesToGB,
  isoToInformalData,
  removeUnderscore,
} from "../../../util/helper";
import SuccessModal from "../../UI/SuccessModal/SuccessModal";
import { authActions } from "../../../store/state-slices/auth";
import { updateProfileDetails } from "../../../store/state-slices/profileDetails";
import { updateStorageDetails } from "../../../store/state-slices/storageDetails";
import PageLoader from "../../UI/Loader/PageLoader";
import { FileUploadContext } from "../FileUploadLayout";
import decryptUrl from "../../../util/img-decryption";
import DynamicForm from "../../DynamicFrom/DynamicForm";
import PlansContainer from "../../UI/PlansContainer/PlansContainer";
import {
  setAccessModalClose,
  setActiveModalClose,
  setPlanModalClose,
  setSubscriptionPlan,
  setPremiumAlertModalClose,
  setReindexAlertModalClose,
} from "../../../store/state-slices/plans";
import ActiveAlert from "../../UI/ActiveAlert/ActiveAlert";
import { emptyObj } from "../../../util/validation";
import AccessAlert from "../../UI/AccessAlert/AccessAlert";
import ReindexAlert from "../../UI/ReindexAlert/ReindexAlert";
import {
  openCreateModal,
  closeCreateModal,
  setCreateModalState,
  setEventNotFoundJitoUser,
} from "../../../store/state-slices/modalControl";
import CreateNewEvent from "../../CreateNewEvent/CreateNewEvent";

const NotificationBtn = (props) => {
  return (
    <Tooltip label="Notification" position="bottom">
      <Button icon="IcNotification" {...props} />
    </Tooltip>
  );
};

const ProfileBtn = (props) => {
  const profileDetails = useSelector(
    (state) => state.profileDetails.profileDetails,
  );
  return (
    <Tooltip label="Profile" position="bottom">
      <Box sx={{ "& .j-JDSImage-image": { height: "100%" } }}>
        <Button {...props}>
          <AvatarV2
            avatarKind={
              addParamsURL(profileDetails?.profilePictureThumbnailUrl, {
                size: "s",
              })
                ? "image"
                : "icon"
            }
            // image={
            //   profileDetails?.profilePictureThumbnailUrl
            //     ? decryptUrl(profileDetails?.profilePictureThumbnailUrl)
            //     : ""
            // }
            image={
              profileDetails?.profilePictureThumbnailUrl
                ? addParamsURL(profileDetails?.profilePictureThumbnailUrl, {
                  size: "s",
                })
                : ""
            }
            isClickable={true}
            onClick={() => {
              // setOpen(true);
            }}
          />
        </Button>
      </Box>
    </Tooltip>
  );
};
export default function Navbar(props) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { id } = useParams();
  const { setTasks, setDownloadTasks } = useContext(FileUploadContext);
  const mobileViewPort = window.innerWidth <= 480;
  // const profileDetails = JSON.parse(localStorage.profileDetails || "{}");
  const profileDetails = useSelector(
    (state) => state.profileDetails.profileDetails,
  );
  const isCreateModalCloseGlobal = useSelector(
    (state) => state.modal.isCreateModalClose,
  );
  const { value: isOpen, toggle } = useToggle();
  const { isLoading: isGettingProfile, sendRequest: getProfile } = useApiHttp();
  const { isLoading: isGettingVendorEventId, sendRequest: getVendorEventId } =
    useApiHttp();
  const location = useLocation().pathname;
  const [viewProfile, setViewProfile] = useState(false);
  const [profileModal, setProfileModal] = useState(true);
  const [planModalHead, setPlansModalHead] = useState("Plans");
  const [isCreateModalClose, setCreateModalClose] = useState(
    isCreateModalCloseGlobal,
  );
  const [successModal, setSuccessModal] = useState(true);
  const [updateProfile, setUpdateProfile] = useState(true);
  const [eventId, setEventId] = useState("");
  const [logoutConfirmation, setLogoutConfirmation] = useState(true);
  const [logoutConfirmationUP, setLogoutConfirmationUP] = useState(true);
  const { isLoading: isLogingOut, sendRequest: logoutUser } = useApiHttp();
  const [dynamicFormHead, setDynamicFormHead] = useState(true);
  const [expired, setExpired] = useState(false);
  const [createEventModelOpen, setCreateEventModelOpen] = useState(false);
  const { totalCount } = useSelector((state) => state.uploadPhotos.totalCount);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    planModalClose,
    activeModalClose,
    accessModalClose,
    premiumAlertModalClose,
    reindexAlertModalClose,
  } = useSelector((state) => state.plans);
  const { isAdmin } = useSelector((state) => state.role);
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails,
  );
  const loginDetails = useSelector((state) => state.auth.loginDetails);
  const isJitoUser = loginDetails?.userType === "JITO";
  const eventJWT = localStorage.getItem("eventJWT");
  const [vendorEventId, setVendorEventId] = useState(null);

  console.log("Navbar===", isAdmin);

  const menuRef = useRef();

  useEffect(() => {
    console.log("hello", location);
    console.log("loginDetails====>", loginDetails);
    if (
      location !== "/" &&
      location !== "/sign-up/" &&
      location !== "/login" &&
      location !== "/easy-share/"
    ) {
      getProfile(
        {
          base: "AUTH",
          url: `profile`,
          method: "GET",
        },
        null,
        (data) => {
          dispatch(
            authActions.setLoginDetails({ userType: data?.data?.userType }),
          );
          dispatch(
            updateProfileDetails({
              profileDetails: data?.data,
            }),
          );
          if (
            data?.data?.profilePictureThumbnailUrl == null ||
            data?.data?.firstName == null ||
            data?.data?.lastName == null
          ) {
            navigate("/profile");
          } else if (data?.data?.userType === "JITO") {
            // vendorEventId API
            getVendorEventId(
              {
                url: `event/get-vendor-event/${eventJWT}`,
              },
              null,
              (data) => {
                console.log("jito==>", data);
                setVendorEventId(data?.data?.id);
                navigate(`/home/events/albums/${data?.data?.id}`, {
                  replace: true,
                });
              },
              (err, data) => {
                console.log(err);
                console.log("jito==>", data);
                if (data?.statusCode === 404 && eventJWT) {
                  setVendorEventId(data?.data?.id);
                  navigate("/create-event");
                } else {
                  dispatch(setEventNotFoundJitoUser(true));
                  navigate("/jito-user", {
                    replace: true,
                  });
                }
              },
            );
          }
        },
      );
    }
  }, [updateProfile]);

  const handleViewProfile = (e) => {
    setViewProfile(e.currentTarget);
  };

  const handleCloseProfile = () => {
    setViewProfile(null);
  };

  // Keep local state in sync with Redux updates
  useEffect(() => {
    setCreateModalClose(isCreateModalCloseGlobal);
    console.log("isCreateModalCloseGlobal====>", isCreateModalCloseGlobal);
  }, [isCreateModalCloseGlobal]);

  // Update Redux whenever Navbar button is clicked
  const handleModalToggle = () => {
    const newState = !isCreateModalClose;
    setCreateModalClose(newState);
    dispatch(setCreateModalState(newState));
  };
  return (
    <>
      <JdsModal
        size="m"
        header="Do you want to sign out?"
        kind="dialog"
        primaryCTA={{
          title: "Yes",
        }}
        secondaryCTA={{
          title: "No",
        }}
        close={logoutConfirmation}
        onClose={() => setLogoutConfirmation(true)}
        onPrimaryClick={() => {
          if (totalCount === 0 || totalCount === undefined) {
            logoutUser(
              {
                base: "AUTH",
                url: `user/web-logout`,
                method: "POST",
                body: {
                  accessToken: localStorage.authToken,
                  refreshToken: localStorage.refreshToken,
                },
              },
              null,
              (data) => {
                setTasks([]);
                setDownloadTasks([]);
                Notifications.toast.success({
                  id: "logout",
                  title: data.message,
                });
                dispatch(uploadPhotosActions.setTotalCount({ totalCount: 0 }));
                dispatch(authActions.setLogout());
                window.location.href = process.env.REACT_APP_JIOCLOUD_HOME_URL;

                // navigate("/auth/signin");
              },
            );
          } else {
            console.log(totalCount);
            setLogoutConfirmation(true);
            setLogoutConfirmationUP(false);
          }
        }}
        onSecondaryClick={() => setLogoutConfirmation(true)}
        primaryCtaDisabled={isLogingOut}
      />
      <JdsModal
        size="m"
        header="Uploading in progress"
        kind="dialog"
        primaryCTA={{
          title: "Cancel",
        }}
        secondaryCTA={{
          title: "Continue uploading",
        }}
        close={logoutConfirmationUP}
        onPrimaryClick={() => {
          setLogoutConfirmationUP(true);
          logoutUser(
            {
              base: "AUTH",
              url: `user/web-logout`,
              method: "POST",
              body: {
                accessToken: localStorage.authToken,
                refreshToken: localStorage.refreshToken,
              },
            },
            null,
            (data) => {
              setTasks([]);
              setDownloadTasks([]);
              Notifications.toast.success({
                id: "logout",
                title: data.message,
              });
              dispatch(uploadPhotosActions.setTotalCount({ totalCount: 0 }));
              dispatch(authActions.setLogout());
              window.location.href = process.env.REACT_APP_JIOCLOUD_HOME_URL;
              // navigate("/auth/signin");
            },
          );
        }}
        onSecondaryClick={() => setLogoutConfirmationUP(true)}
      />
      <Popover
        id={viewProfile ? "simple-popover" : undefined}
        open={viewProfile}
        anchorEl={Boolean(viewProfile)}
        onClose={handleCloseProfile}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPaper-root.MuiPopover-paper": {
            borderRadius: "24px",
            backgroundColor: "var(--color-primary-grey-20)",
            boxShadow: "var(--box-shadow-card)",
            padding: "8px",
            padding: "20px 24px 32px",
            width: "432px",
            maxHeight: "720px",
            overflow: "auto",
          },
        }}>
        <h1>hello</h1>
      </Popover>

      <nav className={classes.nav}>
        <ul className={classes["nav__list"]}>
          {!isAuthenticated ? (
            !mobileViewPort ? (
              <>
                <li>
                  <NavLink
                    className={classes["nav__link"]}
                    onClick={(e) => {
                      e.preventDefault();
                      const targetElement =
                        document.querySelector("#section-4");

                      targetElement.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }}>
                    How it works
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink className={classes["nav__link"]} to="/auth/signup">
                    Sign up
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    className={classes["nav__link"]}
                    // to={isAuthenticated ? "/home" : "/auth/signin"}
                    to={process.env.REACT_APP_JIOCLOUD_LANDING_URL}>
                    {isAuthenticated ? "Home" : "Sign in"}
                  </NavLink>
                </li>
              </>
            ) : (
              <>
                <Button
                  kind="tertiary"
                  icon={"IcBurgerMenu"}
                  onClick={toggle}
                />
                <SidePanel open={isOpen} onClose={toggle} direction="right">
                  <Container
                    direction="column"
                    gap={24}
                    style={{ padding: "24px" }}>
                    <NavLink
                      onClick={(e) => {
                        e.preventDefault();
                        const targetElement =
                          document.querySelector("#section-4");

                        targetElement.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }}>
                      <Text appearance="body-m-bold" text="How it works" />
                    </NavLink>
                    <NavLink to={isAuthenticated ? "/home" : "/auth/signin"}>
                      <Text
                        appearance="body-m-bold"
                        text={isAuthenticated ? "Home" : "Sign in"}
                      />
                    </NavLink>
                    {/* <NavLink to="/auth/signup">
                      <Text appearance="body-m-bold" text="Sign up" />
                    </NavLink> */}
                  </Container>
                </SidePanel>
              </>
            )
          ) : (
            <div className="navbar--items">
              {isAdmin && (
                <>
                  {/* <li>
                    {!isJitoUser && (
                      <ActionButton
                        className={`${classes["btn--event"]} new-event-button`}
                        kind="secondary"
                        appearance="contrast"
                        label="New Event"
                        icon="IcAdd"
                        onClick={handleModalToggle}
                      />
                    )}

                    <JdsModal
                      header={
                        expired
                          ? ""
                          : dynamicFormHead
                            ? profileDetailsRedux?.userType === "SCHOOL"
                              ? "Student Information Form"
                              : "Guest Information Form"
                            : "Create New Event"
                      }
                      size="m"
                      close={isCreateModalClose}
                      onClose={handleModalToggle}
                      kind={isJitoUser ? "dialog" : "custom"}
                      headerProps={{
                        divider: expired ? "false" : "true",
                      }}
                      isClosable={isJitoUser ? false : true}
                      contentContainerProps={{
                        className: "w800",
                      }}>
                      {!isCreateModalClose && (
                        <CreateNewEventForm
                          setSuccessModal={setSuccessModal}
                          setEventId={setEventId}
                          setDynamicFormHead={setDynamicFormHead}
                          setExpired={setExpired}
                          userType={loginDetails?.userType}
                          isJitoUser={isJitoUser}
                          vendorEventId={eventJWT}
                        />
                      )}
                    </JdsModal>
                  </li> */}
                  <li>
                    {!isJitoUser && (
                      <ActionButton
                        className={`${classes["btn--event"]} new-event-button`}
                        kind="secondary"
                        appearance="contrast"
                        label="New Event"
                        icon="IcAdd"
                        onClick={handleModalToggle}
                      />
                    )}
                    {/* setCreateEventModelOpen */}
                    <Modal
                      open={!isCreateModalClose}
                      onClose={handleModalToggle}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                      sx={{
                        zIndex: "60",
                      }}>
                      <CreateNewEvent
                        setSuccessModal={setSuccessModal}
                        setEventId={setEventId}
                        vendorEventId={eventJWT}
                        closeModal={handleModalToggle}
                      />
                    </Modal>
                  </li>
                </>
              )}
              {!isJitoUser && (
                <li>
                  <NotificationPopover
                    eventId={eventId}
                    trigger={{
                      component: NotificationBtn,
                    }}
                    onClick={() => {
                      console.log("clicked");
                    }}
                  />
                </li>
              )}
              <li ref={menuRef}>
                <MuiPopover
                  trigger={{
                    component: ProfileBtn,
                    props: {
                      size: "small",
                      kind: "tertiary",
                    },
                  }}
                  sx={{
                    // padding: "20px 24px 32px",
                    width: "384px",
                    maxHeight: "720px",
                    overflow: "auto",
                    backgroundColor: "#fff",
                    padding: 0,
                  }}>
                  <NewProfileViewContainer
                    openLogoutConfirmation={() => {
                      setLogoutConfirmation(false);
                    }}
                    setProfileModal={setProfileModal}
                  />
                </MuiPopover>
                {/* <MenuBlock
                  open={open}
                  onClose={() => setOpen(false)}
                  anchorEl={menuRef}
                  items={[
                    {
                      type: "heading",
                      label: "Fruits",
                    },
                  ]}
                >
                  <h1>hello</h1>
                </MenuBlock> */}
              </li>
            </div>
          )}
        </ul>
      </nav>
      <JdsModal
        header="Profile Details"
        close={profileModal}
        onClose={() => {
          setProfileModal(true);
        }}
        size="m">
        {!profileModal && (
          <ProfileDetailForm
            updateProfile={() => {
              setUpdateProfile((pre) => !pre);
            }}
          />
        )}
      </JdsModal>

      {/* subscription plan modal */}
      <JdsModal
        header={planModalHead}
        close={planModalClose}
        onClose={() => {
          dispatch(setPlanModalClose(true));
        }}
        size="m">
        {!planModalClose && (
          <PlansContainer setPlansModalHead={setPlansModalHead} />
        )}
      </JdsModal>

      {/* active alert plan modal */}
      <JdsModal
        header=""
        kind="informational"
        close={activeModalClose}
        onClose={() => {
          dispatch(setActiveModalClose(true));
        }}
        size="m">
        {!activeModalClose && <ActiveAlert />}
      </JdsModal>

      {/* access alert plan modal */}
      <JdsModal
        header=""
        kind="informational"
        close={accessModalClose}
        onClose={() => {
          dispatch(setAccessModalClose(true));
        }}
        size="m">
        {!accessModalClose && <AccessAlert />}
      </JdsModal>

      {/* premium alert  modal */}
      <JdsModal
        header=""
        kind="informational"
        close={premiumAlertModalClose}
        onClose={() => {
          dispatch(setPremiumAlertModalClose(true));
        }}
        size="m">
        {!premiumAlertModalClose && (
          <Container
            style={{ alignItems: "center", width: "100%" }}
            fullWidth
            gap={16}
            direction="column">
            <Icon ic={"IcAlert"} kind="background" size="xxl" />

            <p
              style={{
                color: "var(--color-primary-grey-80)",
                fontSize: "18px",
                fontWeight: "700",
                textAlign: "center",
              }}>
              Please set the premium image plans to enable premium feature.{" "}
            </p>
            <Button
              label="Premium Image Plans"
              icon={"IcArrowNext"}
              onClick={() => {
                navigate(`/home/events/settings/${id}/premium-image-cost`);
                dispatch(setPremiumAlertModalClose(true));
              }}
            />
          </Container>
        )}
      </JdsModal>
      {/* reindex alert modal */}
      <JdsModal
        header=""
        kind="informational"
        close={reindexAlertModalClose}
        onClose={() => {
          dispatch(setReindexAlertModalClose(true));
        }}
        size="m">
        {!reindexAlertModalClose && <ReindexAlert shadow={false} />}
      </JdsModal>

      <SuccessModal
        close={successModal}
        onClose={() => {
          setSuccessModal(true);
        }}
        btnAction={() => {
          setSuccessModal(true);
          if (isJitoUser) {
            navigate(`/home/events/albums/${eventId}`);
          } else {
            navigate(`/home/events/event-detail/${eventId}`);
          }
        }}
        btnText={isJitoUser ? "Upload Photos" : "Go to Event"}
        kind={isJitoUser ? "dialog" : "informational"}
        isClosable={isJitoUser ? false : true}
      />
      {(isGettingProfile || isGettingVendorEventId) && (
        <PageLoader open={isGettingProfile || isGettingVendorEventId} />
      )}
    </>
  );
}

const ProfileViewContainer = (props) => {
  const { openLogoutConfirmation } = props;
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails,
  );

  const { isLoading: isLogingOut, sendRequest: logoutUser } = useApiHttp();
  const { sendRequest: getStorage, isLoading: isStorageGetting } = useApiHttp();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [storageDetails, setStorageDetails] = useState({});
  const [storagePercentage, setStoragePercentage] = useState(0);
  const [storageState, setStorageState] = useState("none");
  const isStorageAllocated = !emptyObj(storageDetails);
  useEffect(() => {
    // getStorage(
    //   {
    //     // url: `get-storage-details`,
    //     url: `storage/user`,
    //     method: "GET",
    //     base: "MEDIA",
    //   },
    //   null,
    //   (data) => {
    //     console.log(bytesToGB(data?.data?.totalStorageSizeInBytes));
    //     const usedStorage = bytesToGB(data?.data?.usedStorageSizeInBytes);
    //     const totalStorage = bytesToGB(data?.data?.totalStorageSizeInBytes);
    //     // const percentage = Math.round(
    //     //   (data?.data?.siMath.roundzeInGb / data?.data?.totalStorageSizeInGb) * 100
    //     // );
    //     const percentage = Math.round((usedStorage / totalStorage) * 100);
    //     setStorageState(
    //       percentage < 75
    //         ? "none"
    //         : percentage >= 75 && percentage < 90
    //         ? "warning"
    //         : "error"
    //     );
    //     setStoragePercentage(percentage);
    //     setStorageDetails({
    //       ...data?.data,
    //       sizeInGb: usedStorage.toFixed(2),
    //       totalStorageSizeInGb: totalStorage,
    //     });
    //   },
    //   (err, data) => {
    //     console.log("err==>" + data);
    //   }
    // );
  }, []);
  return (
    <Container
      direction="column"
      gap={16}
      fullWidth
      style={{ border: "1px solid " }}>
      <Container fullWidth direction="column" gap={0}>
        <Container
          verticalAlign="center"
          horizontalAlign="center"
          fullWidth
          direction="column"
          gap={20}>
          <AvatarView
            // image={
            //   profileDetailsRedux?.profilePictureThumbnailUrl
            //     ? decryptUrl(profileDetailsRedux?.profilePictureThumbnailUrl)
            //     : ""
            // }
            image={
              profileDetailsRedux?.profilePictureThumbnailUrl
                ? decryptUrl(profileDetailsRedux?.profilePictureThumbnailUrl)
                : ""
            }
            onClick={() => {
              props.setProfileModal(false);
              props.close();
            }}
          />
          {profileDetailsRedux?.firstName && (
            <Text
              text={` Hi ${profileDetailsRedux?.firstName}`}
              appearance="body-m-bold"
            />
          )}

          {/* <Text text="Notification" appearance="body-m-bold" /> */}
          {isStorageAllocated && (
            <Container
              fullWidth
              direction="column"
              horizontalAlign="center"
              verticalAlign="center"
              style={{
                padding: "16px 40px",
                backgroundColor: "#fff",
                borderRadius: "24px",
              }}>
              <Container
                direction="row"
                horizontalAlign="center"
                verticalAlign="center"
                gap={10}>
                <img src={IconCloud} style={{ width: "32px" }} alt="" />
                <Text text={`My Storage`} appearance="body-m-bold" />
              </Container>
              <Container
                verticalAlign="center"
                fullWidth
                horizontalAlign="center"
                direction="column">
                <ProgressBar state={storageState} value={storagePercentage} />
                {isStorageGetting ? (
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "14px", width: "100%" }}
                  />
                ) : (
                  <>
                    <Text
                      text={` ${parseFloat(storageDetails?.sizeInGb).toFixed(
                        2,
                      )}GB of ${storageDetails?.totalStorageSizeInGb?.toFixed(
                        2,
                      )}GB`}
                      color="primary_grey_80"
                      appearance="body-xs"
                    />
                  </>
                )}
                <Container fullWidth direction="column" gap={10}>
                  <Container
                    direction="row"
                    fullWidth
                    horizontalAlign="space-between">
                    <Text text={`Plan`} appearance="body-xs-bold" />
                    {!storageDetails?.planActive && !isStorageGetting && (
                      <BadgeV2
                        label="Expired"
                        icon="IcAlert"
                        size="large"
                        backgroundInfoColor={"var(--color-feedback-error-50)"}
                      />
                    )}
                  </Container>
                  <Container>
                    <Text
                      text={storageDetails?.planType}
                      appearance="body-m-bold"
                    />
                  </Container>
                  <Container
                    fullWidth
                    direction="row"
                    horizontalAlign="space-between">
                    <Text
                      text={`${storageDetails?.planActive ? "Expires on" : "Expired on"
                        }`}
                      color="primary_grey_80"
                      appearance="body-xs"
                    />
                    <Text
                      text={isoToInformalData(storageDetails?.expiryDate)}
                      appearance="body-xs"
                    />
                  </Container>
                </Container>
              </Container>
              <ActionButton
                size="medium"
                kind="primary"
                iconPosition="right"
                icon={<img src={IconRocket} alt="" />}
                appearance="positive"
                onClick={() => {
                  dispatch(setPlanModalClose(false));
                  if (
                    !storageDetails?.planActive ||
                    storageDetails?.freeTrialPlanActive
                  ) {
                    dispatch(setSubscriptionPlan(true));
                  } else {
                    dispatch(setSubscriptionPlan(false));
                  }
                  props.close();
                }}
                label={
                  !storageDetails?.planActive ||
                    storageDetails?.freeTrialPlanActive
                    ? "Subscribe"
                    : "Upgrade"
                }></ActionButton>
            </Container>
          )}
          {/* <Container
            fullWidth
            direction="column"
            style={{
              padding: "16px 16px",
              backgroundColor: "#fff",
              borderRadius: "24px",
            }}
            gap={10}
          >
            <Container direction="row">
              <Text text={`Plan`} appearance="body-xs-bold" />
            </Container>
            <Container>
              <Text text={`₹ 999`} appearance="body-m-bold" />
            </Container>
            <Container
              fullWidth
              direction="row"
              horizontalAlign="space-between"
            >
              <Text
                text={`Expires on`}
                color="primary_grey_80"
                appearance="body-xs"
              />
              <Text text={`31st Dec, 2024`} appearance="body-xs" />
            </Container>
          </Container> */}

          <Box
          // sx={{
          //   "& .text-atom": {
          //     color: "var(--custom-color-primary-60)",
          //   },
          //   ".j-JDSButton-container:hover": {
          //     borderColor: "var(--custom-color-primary-60)",
          //   },
          //   "& svg > path": { fill: "var(--custom-color-primary-60)" },
          // }}
          >
            <Button
              size="medium"
              iconLeft={"IcLogin"}
              label="Sign out"
              kind="secondary"
              onClick={() => {
                openLogoutConfirmation();
                props.close();
              }}></Button>
          </Box>
        </Container>
      </Container>
    </Container>
  );
};

const NewProfileViewContainer = (props) => {
  const { openLogoutConfirmation } = props;
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails,
  );

  const { isLoading: isLogingOut, sendRequest: logoutUser } = useApiHttp();
  const { sendRequest: getStorage, isLoading: isStorageGetting } = useApiHttp();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [storageDetails, setStorageDetails] = useState({});
  const [storagePercentage, setStoragePercentage] = useState(0);
  const [storageState, setStorageState] = useState("none");
  const isStorageAllocated = !emptyObj(storageDetails);
  useEffect(() => {
    // getStorage(
    //   {
    //     // url: `get-storage-details`,
    //     url: `storage/user`,
    //     method: "GET",
    //     base: "MEDIA",
    //   },
    //   null,
    //   (data) => {
    //     console.log(bytesToGB(data?.data?.totalStorageSizeInBytes));
    //     const usedStorage = bytesToGB(data?.data?.usedStorageSizeInBytes);
    //     const totalStorage = bytesToGB(data?.data?.totalStorageSizeInBytes);
    //     // const percentage = Math.round(
    //     //   (data?.data?.siMath.roundzeInGb / data?.data?.totalStorageSizeInGb) * 100
    //     // );
    //     const percentage = Math.round((usedStorage / totalStorage) * 100);
    //     setStorageState(
    //       percentage < 75
    //         ? "none"
    //         : percentage >= 75 && percentage < 90
    //         ? "warning"
    //         : "error"
    //     );
    //     setStoragePercentage(percentage);
    //     setStorageDetails({
    //       ...data?.data,
    //       sizeInGb: usedStorage.toFixed(2),
    //       totalStorageSizeInGb: totalStorage,
    //     });
    //     dispatch(
    //       updateStorageDetails({
    //         storageDetails: {
    //           ...data?.data,
    //           sizeInGb: usedStorage.toFixed(2),
    //           totalStorageSizeInGb: totalStorage,
    //         },
    //       })
    //     );
    //   },
    //   (err, data) => {
    //     console.log("err==>" + data);
    //   }
    // );
  }, []);
  return (
    <Container
      fullWidth
      direction="column"
      gap={16}
      style={{
        borderRadius: "24px",
        border: "1px solid var(--color-primary-grey-60)",
      }}>
      <Container
        verticalAlign="center"
        // horizontalAlign="center"
        fullWidth
        direction="column"
        gap={20}>
        <Box
          sx={{
            padding: "12px",
            borderBottom: "1px solid var(--color-primary-grey-60)",
            width: "100%",
          }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              bgcolor: "#f5f5f5ff",
              width: "100%",
              borderRadius: "16px",
              padding: "16px 24px",
            }}>
            <Stack flexDirection="row" alignItems={"center"} gap={2}>
              <AvatarView
                size="xtra-large"
                kind="default"
                // image={
                //   profileDetailsRedux?.profilePictureThumbnailUrl
                //     ? decryptUrl(
                //       profileDetailsRedux?.profilePictureThumbnailUrl
                //     )
                //     : ""
                // }
                image={
                  profileDetailsRedux?.profilePictureThumbnailUrl
                    ? addParamsURL(
                      profileDetailsRedux?.profilePictureThumbnailUrl,
                      { size: "s" },
                    )
                    : ""
                }
              />
              <MuiTooltip
                title={
                  `${profileDetailsRedux?.firstName} ${profileDetailsRedux?.lastName}`
                    .length > 21 ? (
                    <Text
                      text={`${profileDetailsRedux?.firstName} ${profileDetailsRedux?.lastName}`}
                      appearance="body-xs"
                      color="white"
                    />
                  ) : (
                    ""
                  )
                }
                placement="top"
                arrow
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, -10],
                        },
                      },
                    ],
                  },
                }}>
                <Box
                  sx={{
                    maxWidth: "155px",
                    whiteSpace: "nowrap",
                  }}>
                  {profileDetailsRedux?.firstName &&
                    profileDetailsRedux?.lastName && (
                      <Text
                        text={`${profileDetailsRedux?.firstName} ${profileDetailsRedux?.lastName}`}
                        // text={`sgafsahgfgfgusgfujvsf`}
                        appearance="body-xs-bold"
                        className="name-overflow"
                      />
                    )}
                  {profileDetailsRedux?.email && (
                    <Text
                      text={`${profileDetailsRedux?.email}`}
                      appearance="body-xxs"
                      color="primary_grey_80"
                    />
                  )}
                </Box>
              </MuiTooltip>
            </Stack>
            <Button
              kind="tertiary"
              label="View"
              // onClick={() => {
              //   props.setProfileModal(false);
              //   props.close();
              // }}
              onClick={() => {
                navigate("/userdetail/edit-profile");
                props.close();
              }}
            />
          </Stack>
        </Box>

        {/* {isStorageAllocated &&
          storageDetails?.planType !== "FREE_TRIAL_AVAILABLE" && (
            <Box
              p="8px 36px 24px"
              sx={{
                width: "100%",
                borderBottom: "1px solid var(--color-primary-grey-60)",
              }}
            >
              <Container
                fullWidth
                direction="column"
                horizontalAlign="space-between"
                verticalAlign="center"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "24px",
                }}
              >
                <Container
                  fullWidth
                  direction="row"
                  verticalAlign="center"
                  horizontalAlign="space-between"
                >
                  <Container
                    direction="row"
                    horizontalAlign="center"
                    verticalAlign="center"
                    gap={10}
                  >
                    <Icon ic={"IcCloud"} color="grey-80" />
                    <Text text={`Storage`} appearance="body-m-bold" />
                  </Container>
                  {storageDetails?.planType != "FREE_TRIAL_AVAILABLE" && (
                    <ActionButton
                      size="medium"
                      kind="primary"
                      iconPosition="right"
                      icon={<img src={IconRocket} alt="" />}
                      appearance="positive"
                      onClick={() => {
                        dispatch(setPlanModalClose(false));
                        if (
                          !storageDetails?.planActive ||
                          storageDetails?.freeTrialPlanActive
                        ) {
                          dispatch(setSubscriptionPlan(true));
                        } else {
                          dispatch(setSubscriptionPlan(false));
                        }
                        props.close();
                      }}
                      label={
                        !storageDetails?.planActive &&
                          !storageDetails?.freeTrialPlanActive
                          ? "Subscribe"
                          : "Upgrade"
                      }
                    />
                  )}
                </Container>
                <Container
                  verticalAlign="center"
                  fullWidth
                  direction="column"
                  gap={12}
                >
                  <ProgressBar state={storageState} value={storagePercentage} />
                  {isStorageGetting ? (
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "14px", width: "100%" }}
                    />
                  ) : (
                    <>
                      <Text
                        text={` ${parseFloat(storageDetails?.sizeInGb).toFixed(
                          2
                        )}GB of ${storageDetails?.totalStorageSizeInGb?.toFixed(
                          2
                        )}GB`}
                        color="primary_grey_80"
                        appearance="body-xs"
                      />
                      <Stack sx={{ width: "100%" }} gap={1}>
                        {!storageDetails?.freeTrialPlanActive &&
                          !storageDetails?.planActive && (
                            <Box mb={1}>
                              <BadgeV2
                                label="Plan Expired"
                                icon={"IcAlert"}
                                color="negative"
                                size="large"
                              />
                            </Box>
                          )}
                        <Container
                          fullWidth
                          direction="row"
                          horizontalAlign="space-between"
                          verticalAlign="center"
                        >
                          <Text
                            text={"Plan"}
                            appearance="body-xs-bold"
                            color="primary_grey_100"
                          />
                          <Text
                            text={
                              storageDetails?.planType &&
                              removeUnderscore(storageDetails?.planType)
                            }
                            appearance="body-xs"
                            color="primary_grey_80"
                          />
                        </Container>
                        <Container
                          fullWidth
                          direction="row"
                          horizontalAlign="space-between"
                          verticalAlign="center"
                        >
                          <Text
                            text={
                              storageDetails?.planActive
                                ? "Expires on"
                                : "Expired on"
                            }
                            appearance="body-xs-bold"
                            color="primary_grey_100"
                          />
                          <Text
                            text={
                              storageDetails?.expiryDate &&
                              new Date(storageDetails?.expiryDate.slice(0, 10))
                                .toUTCString()
                                .slice(5, 16)
                            }
                            appearance="body-xs"
                            color="primary_grey_80"
                          />
                        </Container>
                      </Stack>
                    </>
                  )}
                </Container>
              </Container>
            </Box>
          )} */}

        {/* <Box sx={{ padding: "0 20px 28px", width: "100%" }}>
          <ActionButton
            size="medium"
            icon={"IcLogin"}
            label="Sign out"
            // kind="tertiary"
            appearance="contrast"
            onClick={() => {
              openLogoutConfirmation();
              props.close();
            }}
          />
        </Box> */}
      </Container>
    </Container>
  );
};
